import React from "react";
import MyBet from "../myBet";
import { POKER_BONUS_RULES } from "./pokerRules";

/**
 * Right-sidebar Rules card in the reference admin's markup (RightSideBar, casino/rules API):
 *   .card.m-b-10 > .card-header > h6.card-title.d-inline-block "Rules"
 *   + .card-body(padding 10px) > one table.table.table-bordered.rules-table per section
 * Payout tables per game live in ./pokerRules.js.
 * Styled by styles/games/poker.css (scoped to the poker cluster tables).
 */
export default function PokerRulesCard({ tables = POKER_BONUS_RULES }) {
  if (!Array.isArray(tables) || tables.length === 0) return null;
  return (
    <div className="card m-b-10">
      <div className="card-header">
        <h6 className="card-title d-inline-block">{"\n          Rules\n          "}</h6>
      </div>{" "}
      <div className="card-body" style={{ padding: "10px" }}>
        {tables.map((t) => (
          <table key={t.hed} className="table table-bordered rules-table">
            <tbody>
              <tr className="text-center">
                <th colSpan={2}>{t.hed}</th>
              </tr>
              {t.rows.map(([nat, val]) => (
                <tr key={nat}>
                  <td width="60%">{nat}</td>
                  <td>{val}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </div>
    </div>
  );
}

/** Right sidebar for the poker-cluster pages: My Bets (+ Rules card when the reference shows one). */
export function PokerRightSide({ bets, onViewMore, rules }) {
  return (
    <>
      <MyBet bets={bets} onViewMore={onViewMore} />{" "}
      {rules ? <PokerRulesCard tables={rules} /> : null}
    </>
  );
}
